import axios from '../axiosServicesLocais';

async function GetValidLocations() {
  const response = await axios.get('admin/locais/v1/locais-validos');
  return response;
}
export default {
  GetValidLocations,
};
